module.exports = __webpack_public_path__ + "img/how_to_join_3.6edcef95.webp";